import {Table} from 'notebook/tables/constants/TableConstants';
import {EvaluatedTable} from 'notebook/tables/excess/EvaluationConstants';
import getPlainTextTable from 'notebook/tables/export/getPlainTextTable';
import TableUtil from 'notebook/tables/TableUtil';

export interface ExtractedTableData {
  columns: Array<string>;
  rows: Array<Array<string>>;
}

export type GetTableDataFn = () => ExtractedTableData;

// Backend truncates to this many sample rows; avoid serializing more than we need.
const MAX_ROWS_FOR_SUGGESTIONS = 20;

export function extractTableDataForSuggestions(
  table: Table,
  computedTable: EvaluatedTable
): ExtractedTableData {
  const numColumns = table.columnLabels.length;
  const columns = Array.from({length: numColumns}, (_, idx) =>
    TableUtil.columnLabelToText(table.columnLabels[idx] ?? null, idx)
  );

  const rows = getPlainTextTable({
    table: table.table.slice(0, MAX_ROWS_FOR_SUGGESTIONS),
    computedTable: computedTable.slice(0, MAX_ROWS_FOR_SUGGESTIONS),
    includeCellValueModifiers: false,
  });

  return {columns, rows: stripTrailingEmptyRows(rows)};
}

function stripTrailingEmptyRows(rows: Array<Array<string>>): Array<Array<string>> {
  let lastNonEmpty = rows.length - 1;
  while (lastNonEmpty >= 0 && rows[lastNonEmpty].every((cell) => cell == null || cell === '')) {
    lastNonEmpty--;
  }
  return rows.slice(0, lastNonEmpty + 1);
}
